// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pC62x","socialLinks":"Footer_socialLinks__cJMF2","socialLink":"Footer_socialLink__aS9sn","copyright":"Footer_copyright__7WvQ2"};